import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTelegramWebApp } from '@/types/telegram'

export const useBackButton = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const webApp = useTelegramWebApp()

  useEffect(() => {
    if (!webApp) return

    const isMainPage = location.pathname === '/'

    if (isMainPage) {
      // На главной странице скрываем кнопку назад
      webApp.BackButton?.hide()
      return
    } else {
      // На всех остальных страницах показываем и добавляем функцию "Назад"
      const handleBack = () => {
        navigate(-1)
      }

      webApp.BackButton?.show()

      // Сначала удаляем старые обработчики, чтобы не дублировать
      webApp.BackButton?.offClick?.(handleBack)
      // Добавляем новый
      webApp.BackButton?.onClick(handleBack)

      // Cleanup function to remove the listener when component unmounts or dependency changes
      return () => {
        webApp.BackButton?.offClick?.(handleBack)
      }
    }
  }, [location.pathname, navigate, webApp])
}
